import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { AppService } from 'src/app/app.service';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { LhFirebaseService } from 'src/app/services/fire/lh-fire.service';

@Component({
    selector: 'app-site-rating',
    templateUrl: './site-rating.component.html',
    styleUrls: ['./site-rating.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SiteRatingComponent extends BaseInjectorService implements OnInit {
  siteNameList:any[];
  siteNameListCopy:any[];
  areaZoneList:any[];
  areaZoneListCopy:any[];
  areaNameList:any[];
  areaNameListCopy:any[];
  areaUnitList:any[];
  areaUnitListCopy:any[];
  areaCountryList:any[];
  areaCountryListCopy:any[];
  userTypeRole:any;
  from:any;
  submittedDate:any;

  areaForm = new FormGroup({});
  zoneForm = new FormGroup({});
  siteForm = new FormGroup({});
  unitForm = new FormGroup({});
  countryForm = new FormGroup({});
  dateForm=new FormGroup({});
  fields: FormlyFieldConfig[] = [
    {
      key: 'area_area',
      type: 'input',
      className: 'rating-info-search',
      props: {
        appearance: 'outline',
        label: this.translate.instant('ASSIGNED_SEARCH'),
        type: 'text',
        disabled: false,
        change: (field, $event) => {
        },
      }
    }
  ];
  siteField: FormlyFieldConfig[] = [
    {
      key: 'site_name',
      type: 'input',
      className: 'rating-info-search',
      props: {
        appearance: 'outline',
        label: this.translate.instant('ASSIGNED_SEARCH'),
        type: 'text',
        disabled: false,
        change: (field, $event) => {
        },
      }
    }
  ];
  zoneField: FormlyFieldConfig[] = [
    {
      key: 'zone_name',
      type: 'input',
      className: 'rating-info-search',
      defaultValue:'',
      props: {
        appearance: 'outline',
        label: this.translate.instant('ASSIGNED_SEARCH'),
        type: 'text',
        disabled: false,
        change: (field, $event) => {
        },
      }
    }
  ];
  unitField: FormlyFieldConfig[] = [
    {
      key: 'unit_name',
      type: 'input',
      className: 'rating-info-search',
      defaultValue:'',
      props: {
        appearance: 'outline',
        label: this.translate.instant('ASSIGNED_SEARCH'),
        type: 'text',
        disabled: false,
        change: (field, $event) => {
        },
      }
    }
  ];
  countryField: FormlyFieldConfig[] = [
    {
      key: 'country_name',
      type: 'input',
      className: 'rating-info-search',
      defaultValue:'',
      props: {
        appearance: 'outline',
        label: this.translate.instant('ASSIGNED_SEARCH'),
        type: 'text',
        disabled: false,
        change: (field, $event) => {
        },
      }
    }
  ];
  dateField:FormlyFieldConfig[]=[
    {
      key: 'dueDateTime',
      type: 'datepicker',
      className: 'rating-info-date',
      props: {
        appearance: 'outline',
        label: this.translate.instant("ACTION.FORM_DUEDATE_PLACEHOLDER"),
        placeholder: 'DD-MM-YYYY',
        required: true,
        disabled:false,
        datepickerOptions: { min: null ,max:null}
      }
    }, 
  ];
  model = {};
  options: FormlyFormOptions = {};
  segmentName: any;
  showCountry: boolean=true;
  constructor(private lhFirebaseService: LhFirebaseService,public service:AppService,
    private detectChanges: ChangeDetectorRef) {
    super()
   }

  ngOnInit() {
    if(this.from=="filter"){
      let previousYearDate=new Date(new Date().setFullYear(new Date().getFullYear() - 1));
      var date = new Date();
      console.log("this.submittedDate=",this.submittedDate);
      if(this.submittedDate){
        this.dateField[0].defaultValue=this.moment(this.submittedDate).format('YYYY-MM-DD');
        this.dateField[0].props.datepickerOptions.min = this.moment(previousYearDate).format('YYYY-MM-DD')
        //this.dateField[0].props.datepickerOptions.max = this.moment(date).format('YYYY-MM-DD')
      }else{
        this.dateField[0].props.datepickerOptions.min = this.moment(previousYearDate).format('YYYY-MM-DD')
        this.dateField[0].props.datepickerOptions.max = this.moment(date).format('YYYY-MM-DD')
      }
    }
    if(this.userTypeRole=='country_admin' || this.userTypeRole=='country_head_of_hs' || this.userTypeRole=='country_ceo'){
      this.segmentName='country';
    }else if(this.userTypeRole=='unit_manager'){
      this.segmentName='unit';
    }
    else if(this.userTypeRole=='site_manager'){
      this.segmentName='site';
    }
    if(this.userTypeRole=='site_manager' || this.userTypeRole=='unit_manager'){
      this.showCountry=false;
    }
  }

  async ionViewDidEnter(){
    if(this.from=='filter'){
      this.areaCountryList=this.areaCountryListCopy;
      this.areaNameList=this.areaNameListCopy;
      this.areaZoneList=this.areaZoneListCopy;
      this.siteNameList=this.siteNameListCopy;
      this.areaUnitList=this.areaUnitListCopy;
      setTimeout(()=>{
        if(this.userTypeRole=='country_admin' || this.userTypeRole=='country_head_of_hs' || this.userTypeRole=='country_ceo'){
          if(this.segmentName=='country'){
            console.log("areaZoneList=",this.areaZoneList);
            this.countryField[0].formControl.valueChanges
              .subscribe(result => {
                console.log("res=",result);
                if (result == '') { 
                  this.areaCountryList = this.areaCountryListCopy; 
                } else {
                    this.areaCountryList = this.areaCountryListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
                }
                this.detectChanges.detectChanges();
              });
          }
          else if(this.segmentName=='unit'){
            console.log("this.areaUnitList=",this.areaUnitList);
            this.unitField[0].formControl.valueChanges
              .subscribe(result => {
                console.log("res=",result);
                if (result == '') { 
                  this.areaUnitList = this.areaUnitListCopy; 
                } else {
                    this.areaUnitList = this.areaUnitListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
                }
                this.detectChanges.detectChanges();
            });
          }
          else if(this.segmentName=='site'){
            this.siteField[0].formControl.valueChanges
              .subscribe(result => {
                console.log("res=",result);
                if (result == '') { 
                  this.siteNameList = this.siteNameListCopy; 
                } else {
                    this.siteNameList = this.siteNameListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
                }
                this.detectChanges.detectChanges();
            });
          }

        }
        else if(this.userTypeRole=='unit_manager'){
          if(this.segmentName=='unit'){
            console.log("areaZoneList=",this.areaZoneList);
            this.unitField[0].formControl.valueChanges
              .subscribe(result => {
                console.log("res=",result);
                if (result == '') { 
                  this.areaUnitList = this.areaUnitListCopy; 
                } else {
                    this.areaUnitList = this.areaUnitListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
                }
                this.detectChanges.detectChanges();
              });
          }
          else if(this.segmentName=='site'){
            this.siteField[0].formControl.valueChanges
              .subscribe(result => {
                console.log("res=",result);
                if (result == '') { 
                  this.siteNameList = this.siteNameListCopy; 
                } else {
                    this.siteNameList = this.siteNameListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
                }
                this.detectChanges.detectChanges();
            });
          }
          else if(this.segmentName=='area'){
            this.fields[0].formControl.valueChanges
              .subscribe(result => {
                console.log("res=",result);
                if (result == '') { 
                  this.areaNameList = this.areaNameListCopy; 
                } else {
                    this.areaNameList = this.areaNameListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
                }
                this.detectChanges.detectChanges();
            });
          }
        }
        else if(this.userTypeRole=='site_manager'){  
          if(this.segmentName=='site'){
            this.siteField[0].formControl.valueChanges
              .subscribe(result => {
                console.log("res=",result);
                if (result == '') { 
                  this.siteNameList = this.siteNameListCopy; 
                } else {
                    this.siteNameList = this.siteNameListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
                }
                this.detectChanges.detectChanges();
            });
          }
          else if(this.segmentName=='area'){
            this.fields[0].formControl.valueChanges
              .subscribe(result => {
                console.log("res=",result);
                if (result == '') { 
                  this.areaNameList = this.areaNameListCopy; 
                } else {
                    this.areaNameList = this.areaNameListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
                }
                this.detectChanges.detectChanges();
            });
          }
          else if(this.segmentName=='zone'){
            console.log("areaZoneList=",this.areaZoneList);
            this.zoneField[0].formControl.valueChanges
              .subscribe(result => {
                console.log("res=",result);
                if (result == '') { 
                  this.areaZoneList = this.areaZoneListCopy; 
                } else {
                    this.areaZoneList = this.areaZoneListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
                }
                this.detectChanges.detectChanges();
              });
          }
        }
      },1000)
    }
  }

  labelClick(name){
    this.segmentName=name;
    if(this.userTypeRole=='country_admin' || this.userTypeRole=='country_head_of_hs' || this.userTypeRole=='country_ceo'){
      if(this.segmentName=='unit' || this.segmentName=='site'){
        this.ionViewDidEnter();
      } 
    }
    else if(this.userTypeRole=='site_manager'){
      if(this.segmentName=='area'){
        this.ionViewDidEnter();
      }
    }
    else if(this.userTypeRole=='unit_manager'){
      if(this.segmentName=='site'){
        this.ionViewDidEnter();
      }
    }
}
  dismiss(name){
    if(name=='filter'){
      if(this.userTypeRole=='country_head_of_hs'||this.userTypeRole=='country_admin'||this.userTypeRole=='country_ceo'){
        this.countryDissmiss();
      }
      else if(this.userTypeRole=='site_manager'){
        this.siteDissmiss();
      }
      else if(this.userTypeRole=='unit_manager'){
        this.unitDissmiss();
      }
    }else{
      this.modalController.dismiss({sortingValue:name});
    }  
  }
  countryDissmiss(){
    if("dueDateTime" in this.dateForm.value){
      this.submittedDate=this.dateForm.value;
     }else{
      this.submittedDate=undefined;
     }
    this.modalController.dismiss({areaCountryList:this.areaCountryList,
      areaUnitList:this.areaUnitList,siteNameList:this.siteNameList,
      submittedDate:this.submittedDate})
  }
  siteDissmiss(){
    if("dueDateTime" in this.dateForm.value){
      this.submittedDate=this.dateForm.value;
     }else{
      this.submittedDate=undefined;
     }
    this.modalController.dismiss({siteNameList:this.siteNameList,
      areaNameList:this.areaNameList,areaZoneList:this.areaZoneList, submittedDate:this.submittedDate})
  }
  unitDissmiss(){
    if("dueDateTime" in this.dateForm.value){
      this.submittedDate=this.dateForm.value;
     }else{
      this.submittedDate=undefined;
     }
     this.modalController.dismiss({siteNameList:this.siteNameList,areaUnitList:this.areaUnitList,
      areaNameList:this.areaNameList, submittedDate:this.submittedDate})
  }
  clearFilter(){
    this.areaZoneList.forEach(element => {
      element.selected=false;
    });
    this.areaCountryList.forEach(element => {
      element.selected=false;
    });
    this.areaUnitList.forEach(element => {
      element.selected=false;
    });
    this.siteNameList.forEach(element => {
      element.selected=false;
    });
    this.areaNameList.forEach(element => {
      element.selected=false;
    });
    this.areaZoneListCopy=this.areaZoneList;
    this.areaCountryListCopy=this.areaCountryList;
    this.areaUnitListCopy=this.areaUnitList;
    this.siteNameListCopy=this.siteNameList;
    this.areaNameListCopy=this.areaNameList;
    this.submittedDate=undefined;
    if(this.userTypeRole=='country_admin' || this.userTypeRole=='country_head_of_hs' || this.userTypeRole=='country_ceo'){
      this.modalController.dismiss({areaNameList:this.areaNameList,
        siteNameList:this.siteNameList,areaUnitList:this.areaUnitList,
          areaCountryList:this.areaCountryList,submittedDate:this.submittedDate});
    }
    else if(this.userTypeRole=='unit_manager'){
      this.modalController.dismiss({areaNameList:this.areaNameList,
        siteNameList:this.siteNameList,areaUnitList:this.areaUnitList,
          submittedDate:this.submittedDate});
    }
    else if(this.userTypeRole=='site_manager'){
      
      this.modalController.dismiss({areaNameList:this.areaNameList,
        siteNameList:this.siteNameList,
          areaZoneList:this.areaZoneList,submittedDate:this.submittedDate});
    }
    
  }
  closeDismiss(){
    this.modalController.dismiss();
  }
  selectAreaName(name,index){
    
    if(this.segmentName=='zone'){
      this.areaZoneList[index].selected=!this.areaZoneList[index].selected;
    }else if(this.segmentName=='area'){
      this.areaNameList[index].selected=!this.areaNameList[index].selected;
    }
    else if(this.segmentName=='site'){
      this.siteNameList[index].selected=!this.siteNameList[index].selected;
    }
    else if(this.segmentName=='unit'){
      this.areaUnitList[index].selected=!this.areaUnitList[index].selected;
    }
    else if(this.segmentName=='country'){
      this.areaCountryList[index].selected=!this.areaCountryList[index].selected;
    }
    
  }
}
